export default "__VITE_ASSET__BykJDMDV__"